import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApplicationStateService } from 'src/app/services/application-state.service';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { LoadingService } from '../../../core/services/loading/loading.service';

@Component({
  selector: 'app-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss']
})
export class DownloadButtonComponent {

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    private applicationState: ApplicationStateService,
    public router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService
  ) {
    this.activeRoute = this.route;
  }

  public activeRoute: ActivatedRoute;

  @Output() onDownload = new EventEmitter<boolean>(false);

  handleDownloadClick(): void | boolean {
    this.preparePdf();
  }

  private preparePdf(): void | boolean {
    this.loadingService.attach();
    this.onDownload.emit(true);

    setTimeout(() => {
      const viewport = document.querySelector("meta[name=viewport]");
      viewport?.setAttribute('content', 'initial-scale=0.5');

      const primaryText = document.querySelector('.primary-text');
      const secondaryText = document.querySelector('.secondary-text');
      const pill = document.querySelector('index-pill');
      const pillText = pill?.querySelector('span')?.innerText;
      const p = document.createElement('p');

      if (pill !== null && pillText !== null) {
        p.innerText = pillText ? pillText : '';
        pill.classList.add('hidden');
        p.classList.add('text-bold');
        pill.parentNode?.appendChild(p);
      }

      if (primaryText) {
        primaryText.classList.add('hidden');
      }

      if (secondaryText) {
        secondaryText.classList.add('hidden');
      }

      const taxTableCells = document.querySelector('.transaction-totals')?.querySelectorAll('.pb-0');

      taxTableCells?.forEach((tableCell) => {
        tableCell.classList.remove('pb-0');
        tableCell.classList.add('pb-15');
      });

      const data: any = document.querySelector('main.invoice');

      html2canvas(data, {
        allowTaint: true,
        logging: false,
        windowWidth: data.innerWidth,
      })
        .then(canvas => {

          const fileWidth = 210;
          const pageHeight = 295;
          const fileHeight = canvas.height * fileWidth / canvas.width;

          let heightLeft = fileHeight;
          let yPosition = 0;

          const fileURI = canvas.toDataURL('image/png');

          const PDF = new jsPDF('p', 'mm', 'a4', false);

          PDF.addImage(fileURI, 'PNG', 0, 0, fileWidth, fileHeight);

          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            yPosition = heightLeft - fileHeight;
            PDF.addPage('a4', 'p');
            PDF.addImage(fileURI, 'PNG', 0, yPosition, fileWidth, fileHeight);
            heightLeft -= pageHeight;
          }

          PDF.save(`invoice-${this.invoiceTrackingKey}.pdf`);

          taxTableCells?.forEach((tableCell) => {
            tableCell.classList.remove('pb-15');
            tableCell.classList.add('pb-0');
          });

          if (pill !== null && pillText !== null) {
            pill.classList.remove('hidden');
            p.remove();
          }

          if (primaryText) {
            primaryText.classList.remove('hidden');
          }

          if (secondaryText) {
            secondaryText.classList.remove('hidden');
          }

          viewport?.setAttribute('content', 'initial-scale=1');

          this.onDownload.emit(false);
          this.loadingService.deattach();
        })
        .catch((err): any => { console.log('Caught error: ', err); });
    }, 800)

    return false;
  }

}
